import { useState, useEffect } from "react";
import TextField from "@mui/material/TextField";

//Alert stuff: ToDo, move this out on its own component
import Alert from "@mui/material/Alert";
import AlertTitle from "@mui/material/AlertTitle";
import Fade from "@mui/material/Fade";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

// Functions
import postSubmission from "../functions/post-email-subs";

export default function EmailSignUp(props) {
  const [email, setEmail] = useState("");
  const [formSubmitMessageOpen, setFormSubmitMessageOpen] = useState([false, ""]);

  useEffect(() => {
    props.submitEmailFunction.current = submitForm;
    props.passedEmailValue.current = email;
  }, [email]);

  function SubmitFormAlert() {
    if (formSubmitMessageOpen[0]) {
      setTimeout(() => {
        setFormSubmitMessageOpen([false, ""]);
      }, 6000);

      if (formSubmitMessageOpen[1] === "success") {
        return (
          <Fade in={formSubmitMessageOpen[0]}>
            <Box sx={alertBox}>
              <Alert variant="filled" severity="success">
                <AlertTitle>
                  <strong>Form successfully submitted</strong>
                </AlertTitle>
                <Typography> We have received your message and will respond shortly </Typography>
              </Alert>
            </Box>
          </Fade>
        );
      } else {
        return (
          <Fade in={formSubmitMessageOpen[0]}>
            <Box>
              <Alert variant="filled" severity="error">
                <AlertTitle>
                  <strong>Please fix the following fields:</strong>
                </AlertTitle>
                <Typography> {formSubmitMessageOpen[1]} </Typography>
              </Alert>
            </Box>
          </Fade>
        );
      }
    } else {
      return null;
    }
  }

  const submitForm = (email) => {
    //Special handling to use localhost SAM API if running locally via npm start(make run)
    const apiUrl =
      process.env.NODE_ENV !== "development"
        ? "https://api." + process.env.NEXT_PUBLIC_DOMAIN + "/email-sub"
        : process.env.NEXT_PUBLIC_USER_API_URL_LOCAL_SAM + "/email-sub";

    // -----------------------
    // ----- Validations -----
    // -----------------------

    let invalidFields = [];
    const emailRegex =
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    //Ensure email is valid
    if (typeof email === "undefined" || email === "") {
      invalidFields.push("Email ");
    } else if (!email.match(emailRegex)) {
      invalidFields.push("Email ");
    }

    //Ensure page is valid
    if (typeof props.page === "undefined" || props.page === "") {
      props.page = "null";
    }

    // If no invalid fields, call the postSubmission API
    if (invalidFields.length === 0) {
      postSubmission(apiUrl, email, encodeURIComponent(props.page)).then((data) => {
        if (data["message"] === "Successfully submitted form") {
          {
            props.handleSuccessFunction();
          }
        }
      });
    } else {
      setFormSubmitMessageOpen([true, invalidFields]);
    }
  };

  return (
    <div>
      <SubmitFormAlert />
      <TextField
        margin="dense"
        id="name"
        color="info"
        label="Primary Email Address"
        type="email"
        fullWidth
        variant="standard"
        required
        value={email}
        onChange={(email) => setEmail(email.target.value)}
      />
    </div>
  );
}
